import { IconButton, Stack, Typography } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { BASE_URL } from '../../util/Constants';

export function AttachmentPreview({ file }) {
  function fileUrl(file) {
    return `${BASE_URL}/attachments/${file.uuid}/file`;
  }

  function previewImage(file) {
    return !file.mediaType?.includes('heic') ? <img height={550} src={fileUrl(file)} alt={file?.description} /> : previewOther(file);
  }

  function previewPdf(file) {
    return file.mediaType?.includes('pdf') ? <embed height={550} width={890} title={file.url} src={fileUrl(file)} type={file.mediaType} /> : previewOther(file);
  }

  function previewOther(file) {
    return (
      <Stack direction="row" alignItems="center">
        <Typography>{file.fileName}</Typography>
        <a href={fileUrl(file)} download={file.fileName} sx={{ textDecoration: 'none' }}>
          <IconButton variant="contained">
            <DownloadIcon />
          </IconButton>
        </a>
      </Stack>
    );
  }

  return <>{file?.mediaType?.includes('image') ? previewImage(file) : file ? previewPdf(file) : ''}</>;
}
